// Note: These are also managed in TRAPP, so don't change them here without changing them there...
export const API_TOKEN_STORAGE_KEY = 'TR_API_TOKEN';
export const PHOENIX_COOKIE = 'phoenix';
export const REDIRECT_TO_PHOENIX_KEY = 'REDIRECT_TO_PHOENIX';
export const IS_PHOENIX_USER_KEY = 'IS_PHOENIX_USER';
